import React, { useState } from "react";
import ImageAltText from "./ImageAltText";
import ImageCaption from "./ImageCaption";
import { restrictUserInput } from "../../helpers/utilities";

function ImagePreview(props) {
  const { instanceNumber } = props;
  const previewWrapperId = `preview${instanceNumber}`;
  const imgId = `imagePreview${instanceNumber}`;
  const [descriptionText, setDescriptionText] = useState("");
  const [captionText, setCaptionText] = useState("");

  function handleUserInput(input, isAltText) {
    const textValue = restrictUserInput(input, isAltText);
    isAltText ? setDescriptionText(textValue) : setCaptionText(textValue);
  }

  return (
    <div id={previewWrapperId} className="d-none he-grid-row">
      <div className="he-grid-col-md-6">
        <div className="ugc-contribution-modal__upload-image-wrapper">
          <img id={imgId} src="" alt="" />
        </div>
      </div>
      <ImageCaption
        instanceNumber={instanceNumber}
        captionText={captionText}
        restrictUserInput={(input) => handleUserInput(input, false)}
      />
      <ImageAltText
        instanceNumber={instanceNumber}
        descriptionText={descriptionText}
        restrictUserInput={(input) => handleUserInput(input, true)}
      />
    </div>
  );
}

export default ImagePreview;